import {
  MicroNavigatorProvider,
  PageItem,
} from "../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import CreateStreetLightPage from "./CreateStreetLightPage/CreateStreetLightPage";
import SingleStreetLightListPage from "./SingleStreetLightListPage/SingleStreetLightListPage";
import StreetLightListPage from "./StreetLightListPage/StreetLightListPage";
import UpdateStreetLightPage from "./UpdateStreetLightPage/UpdateStreetLightPage";
import { RequireCapability } from "../../../features/rbac";

export const StreetLightPages = () => {
  return (
    <MicroNavigatorProvider>
      <PageItem
        path={"list"}
        PageRender={() => <StreetLightListPage />}
        isDefault
      />
      <PageItem
        path={"create"}
        PageRender={() => <RequireCapability capability="planbt.edit"><CreateStreetLightPage /></RequireCapability>}
      />
      <PageItem 
        path={"single"}
        PageRender={() => <SingleStreetLightListPage />}
      />

      <PageItem
        path={"edit"}
        PageRender={() => <RequireCapability capability="planbt.edit"><UpdateStreetLightPage /></RequireCapability>}
      />
    </MicroNavigatorProvider>
  );
};

export default StreetLightPages;
